// Shared news articles data
export interface NewsArticle {
  id: string
  title: string
  slug: string
  excerpt: string
  content: string
  date: string
  author: string
  category:
    | 'academics'
    | 'sports'
    | 'events'
    | 'achievements'
    | 'announcements'
    | 'business'
    | 'technology'
    | 'health'
    | 'education'
  image: string
  featured?: boolean
  tags: string[]
  source?: string
  sourceUrl?: string
  region?: string
  sentiment?: 'positive' | 'neutral' | 'negative'
}
export const newsArticles: NewsArticle[] = [
  {
    id: '16',
    title:
      'Ogun State School Calendar for 2025/2026 Academic Session published',
    slug: 'ogun-state-school-calendar-2025-2026',
    excerpt:
      'The official academic calendar for the 2025/2026 session has been published, providing clarity and preparedness for schools, teachers, parents and students across Ogun State.',
    content: 'Full article content here...',
    date: '2025-01-20',
    author: 'Ogun State Education',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/hgRGwnKLZHVDTRdgag3Y5F/WhatsApp_Image_2025-10-24_at_10.01.11.jpg',
    featured: false,
    tags: [
      'Academic Calendar',
      'School Planning',
      'Ogun State',
      '2025/2026 Session',
    ],
    source: 'Ogun State Education',
    sourceUrl: 'https://facebook.com',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '15',
    title: 'World Teachers Day: Ogun declares Monday work-free for teachers',
    slug: 'ogun-teachers-day-work-free',
    excerpt:
      'In celebration of World Teachers Day, Ogun State declared Monday 6 October 2025 a work-free day for teachers, acknowledging their invaluable contribution to society.',
    content: 'Full article content here...',
    date: '2025-01-18',
    author: 'Champion News',
    category: 'events',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/3uhcY5Mx6ch6FMKTi9n6s3/WhatsApp_Image_2025-10-24_at_10.01.12.jpg',
    featured: true,
    tags: ['Teachers Day', 'Holiday', 'Ogun State', 'Teacher Appreciation'],
    source: 'Champion News',
    sourceUrl: 'https://championnews.com.ng',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '14',
    title:
      'Abeokuta North shines as teachers emerge top winners at 2025 World Teachers Day',
    slug: 'abeokuta-north-teachers-win-awards',
    excerpt:
      'Educators from Abeokuta North Local Government Area secured multiple awards at state and national levels in recognition of excellence in teaching during the 2025 World Teachers Day celebration.',
    content: 'Full article content here...',
    date: '2025-01-17',
    author: 'Abeokuta North LGA',
    category: 'achievements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    featured: true,
    tags: [
      'Teachers Day',
      'Awards',
      'Abeokuta North',
      'Excellence in Teaching',
    ],
    source: 'Abeokuta North LGA',
    sourceUrl: 'https://abeokutanorth.gov.ng',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '13',
    title: 'Group rallies support for public schools in Ogun State',
    slug: 'ngo-rally-public-schools-support',
    excerpt:
      'NGOs based in the Egba region held a rally in Abeokuta, advocating for enhanced support for public schools through community engagement and partnerships.',
    content: 'Full article content here...',
    date: '2025-01-16',
    author: 'The Punch',
    category: 'education',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg',
    featured: false,
    tags: ['Community Support', 'NGO', 'Public Schools', 'Advocacy'],
    source: 'The Punch',
    sourceUrl: 'https://punchng.com',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '12',
    title:
      'Ogun Govt Moves To Protect Teachers, Declares Zero-Tolerance For Assault',
    slug: 'ogun-teacher-protection-policy',
    excerpt:
      'The state government declared that any assault or intimidation of teachers will lead to full legal consequences, emphasising respect for educators and a safe school environment.',
    content: 'Full article content here...',
    date: '2025-01-15',
    author: 'EDU-BIZ News',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/26CHK6sEK66nfVUNdvbwf4/WhatsApp_Image_2025-10-24_at_10.01.20_%282%29.jpg',
    featured: true,
    tags: [
      'Teacher Protection',
      'School Safety',
      'Ogun State',
      'Government Policy',
    ],
    source: 'EDU-BIZ News',
    sourceUrl: 'https://edu-biznews.com',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '11',
    title:
      'Ogun Secondary School Students vandalised school properties, beat teachers',
    slug: 'ilugun-high-school-vandalism-incident',
    excerpt:
      "At Ilugun High School in Abeokuta, some students reportedly vandalised classrooms and attacked teachers following a student's death, prompting a strong reaction from authorities.",
    content: 'Full article content here...',
    date: '2025-01-14',
    author: 'TVC News',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/fhbXs7UNN6d2HJRiEebjre/WhatsApp_Image_2025-10-24_at_10.01.20.jpg',
    featured: false,
    tags: ['School Safety', 'Student Conduct', 'Ogun State', 'Incident Report'],
    source: 'TVC News',
    sourceUrl: 'https://tvcnews.tv',
    region: 'Nigeria',
    sentiment: 'negative',
  },
  {
    id: '10',
    title:
      'Public schools will resume with improved facilities – Ogun commissioner assures',
    slug: 'ogun-public-schools-infrastructure-upgrade',
    excerpt:
      'Ahead of the 2025/2026 academic session, the Commissioner for Education confirmed public schools in the state will begin with upgraded infrastructure and improved facilities.',
    content: 'Full article content here...',
    date: '2025-01-13',
    author: 'Daily Post',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg',
    featured: true,
    tags: [
      'Infrastructure',
      'Public Schools',
      'Ogun State',
      'School Improvement',
    ],
    source: 'Daily Post',
    sourceUrl: 'https://dailypost.ng',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '9',
    title: 'Ogun govt implements six-year textbook policy',
    slug: 'ogun-six-year-textbook-policy',
    excerpt:
      'Schools in the state are now required to keep textbooks in use for at least six years and avoid frequent changes. Extravagant graduation parties also banned to reduce costs for parents.',
    content: 'Full article content here...',
    date: '2025-01-12',
    author: 'Tribune Online',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/ez9ThFy3DkQ6XwMpYtSRNQ/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    featured: false,
    tags: [
      'Textbook Policy',
      'Cost Reduction',
      'Ogun State',
      'Education Reform',
    ],
    source: 'Nigerian Tribune',
    sourceUrl: 'https://tribuneonlineng.com',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '8',
    title: 'Ogun State government issues new school guidelines',
    slug: 'ogun-new-school-guidelines',
    excerpt:
      'The state government introduced rules such as limiting graduation ceremonies to key transition classes and enforcing a six-year textbook use cycle to reduce costs for parents.',
    content: 'Full article content here...',
    date: '2025-01-11',
    author: 'Lagos Television',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/xtrakyEwXvgXDeA5fP3DPg/WhatsApp_Image_2025-08-14_at_15.45.38_%284%29.jpg',
    featured: false,
    tags: [
      'School Guidelines',
      'Government Policy',
      'Ogun State',
      'Cost Management',
    ],
    source: 'Lagos Television',
    sourceUrl: 'https://ltv.ng',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '7',
    title:
      'Stakeholders call for collective action to transform education sector in Ogun',
    slug: 'ogun-education-stakeholders-call-for-action',
    excerpt:
      'Education stakeholders in Ogun State have urged collaborative efforts among government, schools, parents and communities to boost the quality of education across the state.',
    content: 'Full article content here...',
    date: '2025-01-10',
    author: 'Daily Post',
    category: 'education',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg',
    featured: true,
    tags: ['Education Reform', 'Stakeholders', 'Ogun State', 'Collaboration'],
    source: 'Daily Post',
    sourceUrl: 'https://dailypost.ng',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '6',
    title: 'Ogun school wins N100,000 in science debate',
    slug: 'ogun-school-science-debate-winner',
    excerpt:
      'Graceland School, Magboro, emerged as the winner of the secondary school category of the science debate competition at the 2025 International Science Conference, winning N100,000.',
    content: 'Full article content here...',
    date: '2025-01-07',
    author: 'Grace Edema',
    category: 'achievements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/wR2UiNLTLo6z7JMrJqbjqu/Prize-award.jpg',
    featured: true,
    tags: [
      'Science Competition',
      'Mountain Top University',
      'STEM Education',
      'Innovation',
    ],
    source: 'The PUNCH',
    sourceUrl: 'https://punchng.com',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '0',
    title:
      'NELFUND sensitises Ogun residents as education loan disbursement hits N116bn',
    slug: 'nelfund-education-loan-ogun',
    excerpt:
      "The Managing Director of NELFUND urges Ogun State residents to encourage their children to take advantage of the Federal Government's education loan scheme, with N116bn already disbursed.",
    content: 'Full article content here...',
    date: '2025-01-07',
    author: 'Taiwo Bankole',
    category: 'education',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/dsrQU5mbmzrzjRsiWFUkt8/IMG_20251107_115520_015-2048x1717.jpg',
    featured: true,
    tags: ['NELFUND', 'Education Loan', 'Ogun State', 'Federal Government'],
    source: 'Punch Nigeria',
    sourceUrl: 'https://punchng.com',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '1',
    title: 'Outstanding WAEC Results for Class of 2024',
    slug: 'waec-results',
    excerpt:
      'Our graduating class has achieved exceptional results in the 2024 WAEC examinations, with a 95% distinction rate across all subjects.',
    content: 'Full content...',
    date: '2025-01-15',
    author: "Principal's Office",
    category: 'academics',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg',
    featured: true,
    tags: ['WAEC', 'Examination', 'Results', 'Academic Excellence'],
    source: 'IGS News',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '2',
    title: 'Science Club Wins Regional Competition',
    slug: 'science-competition',
    excerpt:
      'Our Science Club emerged victorious at the Regional Science Competition, showcasing innovative projects.',
    content: 'Full content...',
    date: '2025-01-10',
    author: 'Science Department',
    category: 'achievements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/izoRqPZv7uCHZWbnJ1rXVJ/WhatsApp_Image_2025-10-24_at_13.20.17_%282%29.jpg',
    tags: ['Science', 'Competition', 'Achievement'],
    source: 'IGS News',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '3',
    title: 'New Computer Lab Opens',
    slug: 'computer-lab-opening',
    excerpt:
      'State-of-the-art computer laboratory officially opened to enhance digital learning for students.',
    content: 'Full content...',
    date: '2025-01-05',
    author: 'IT Department',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg',
    tags: ['Technology', 'Infrastructure', 'Digital Learning'],
    source: 'IGS News',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '4',
    title: 'Inter-House Sports Competition Announced',
    slug: 'sports-competition',
    excerpt:
      'Annual Inter-House Sports Competition scheduled for March 2025. All students encouraged to participate.',
    content: 'Full content...',
    date: '2025-01-03',
    author: 'Sports Department',
    category: 'sports',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg',
    tags: ['Sports', 'Competition', 'Inter-House'],
    source: 'IGS News',
    region: 'Nigeria',
    sentiment: 'positive',
  },
  {
    id: '5',
    title: 'Alumni Donation Supports Library Expansion',
    slug: 'library-expansion',
    excerpt:
      'Generous donations from alumni enable major library expansion project to begin.',
    content: 'Full content...',
    date: '2024-12-28',
    author: 'Development Office',
    category: 'announcements',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    tags: ['Alumni', 'Library', 'Infrastructure'],
    source: 'IGS News',
    region: 'Nigeria',
    sentiment: 'positive',
  },
]
